import { fbActions } from '@/extensions/firebase/api/actions/'
import { connectorConfig } from '@/utils/connector_config'

const configuracion = {
	get: (url, params) => {
		return fbActions.get(url, params)
	},
	post: (url, params) => {
		return fbActions.post(url, params)
	},
	put: (url, params) => {
		return fbActions.put(url, params)
	},
	delete: (url, params) => {
		return fbActions.delete(url, params)
	}
}

connectorConfig.configuracion = configuracion
